import { CloseOutlined } from "@ant-design/icons";
import { Dialog } from "@material-ui/core";
import React from "react";
import { Project } from "../../../config/models";
import SimpleDatePicker from "../../simpleDatePicker/SimpleDatePicker";
import styles from "./editProject?.module.scss";

interface appProps {
  onClose: (project?: Project) => void;
  project: Project;
  open: boolean;
}
interface appState {
  project: Project;
  loading: boolean;
  startDatePickerOpen: boolean;
  endDatePickerOpen: boolean;
}

export default class EditProjectModal extends React.Component<
  appProps,
  appState
> {
  onClose: (project?: Project) => void;
  constructor(props: any) {
    super(props);
    this.state = {
      loading: false,
      project: this.props.project,
      startDatePickerOpen: false,
      endDatePickerOpen: false,
    };
    this.onClose = this.props.onClose.bind(this);
  }

  changeName = (event: any) => {
    const p = this.state.project;
    p.name = event.target.value;
    this.setState({
      project: p,
    });
  };

  changeCompany = (event: any) => {
    const p = this.state.project;
    p.companyName = event.target.value;
    this.setState({
      project: p,
    });
  };

  changeClient = (event: any) => {
    const p = this.state.project;
    p.clientName = event.target.value;
    this.setState({
      project: p,
    });
  };

  componentDidUpdate(prevProps: Readonly<appProps>, prevState: Readonly<appState>, snapshot?: any): void {
    if (prevProps.open !== this.props.open) {
      this.setState({ project: this.props.project });
    }
  }

  render() {
    return (
      <div
        className={this.props.open ? "modal fade show" : "modal fade"} /**/
        id="project-editModal"
        tabIndex={-1}
        aria-labelledby="project-editLabel"
        style={
          this.props.open ? { display: "block" } : { display: "none" }
        } /**/
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="project-editLabel">
                프로젝트 수정
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => this.onClose()}
              ></button>
            </div>
            <div className="modal-body">
              <div className="input-content">
                <div className="input-item">
                  <div className="title">프로젝트 이름</div>
                  <div className="contents">
                    <input
                      type="text"
                      className="form-control"
                      aria-label="project-name"
                      aria-describedby="basic-addon1"
                      value={this.state.project?.name}
                      onChange={this.changeName}
                    />
                  </div>
                </div>
                <div className="input-item">
                  <div className="title">회사명</div>
                  <div className="contents">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="회사명을 입력해주세요"
                      aria-label="company-name"
                      aria-describedby="basic-addon1"
                      value={this.state.project?.companyName}
                      onChange={this.changeCompany}
                    />
                  </div>
                </div>
                <div className="input-item">
                  <div className="title">발주처</div>
                  <div className="contents">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="발주처를 입력해주세요"
                      aria-label="orderer-name"
                      aria-describedby="basic-addon1"
                      value={this.state.project?.clientName}
                      onChange={this.changeClient}
                    />
                  </div>
                </div>
                <div className="input-item">
                  <div className="title">시작일</div>
                  <div className="contents">
                    <input
                      type="text"
                      className="form-control hasDatepicker"
                      id="datepicker-start"
                      onClick={() =>
                        this.setState({ startDatePickerOpen: true })
                      }
                      value={
                        this.state.project?.startDate
                          ? this.state.project?.startDate.format("yyyy-MM-dd")
                          : ""
                      }
                    />
                  </div>
                </div>
                <div className="input-item">
                  <div className="title">종료일</div>
                  <div className="contents">
                    <input
                      type="text"
                      className="form-control hasDatepicker"
                      id="datepicker-end"
                      onClick={() => this.setState({ endDatePickerOpen: true })}
                      value={
                        this.state.project?.endDate
                          ? this.state.project?.endDate.format("yyyy-MM-dd")
                          : ""
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <div className="modal-footer-wrap">
                <button
                  type="button"
                  className="btn btn-light btn-lg flex-1"
                  data-bs-dismiss="modal"
                  onClick={() => this.onClose()}
                >
                  취소
                </button>
                <button
                  type="button"
                  className="btn btn-primary btn-lg flex-2"
                  data-bs-dismiss="modal"
                  onClick={() => {
                    this.onClose(this.state.project);
                  }}
                >
                  <span className="material-symbols-outlined me-2">done</span>
                  저장하기
                </button>
              </div>
            </div>
          </div>
        </div>
        <SimpleDatePicker
          open={this.state.startDatePickerOpen}
          onClose={(result: Date) => {
            const p = this.state.project;
            p.startDate = result;
            this.setState({ startDatePickerOpen: false, project: p });
          }}
          selectedDate={this.state.project?.startDate || new Date()}
        />
        <SimpleDatePicker
          open={this.state.endDatePickerOpen}
          onClose={(result: Date) => {
            const p = this.state.project;
            p.endDate = result;
            this.setState({ endDatePickerOpen: false, project: p });
          }}
          selectedDate={this.state.project?.endDate || new Date()}
        />
      </div>
    );
  }
}
